const BROWSER_SESSION_LOCK_NAME = 'soundops-browser-session';

export class BrowserSessionLockUnavailableError extends Error {
  constructor() {
    super(
      'Browser sessions require HTTPS or localhost and a browser with Web Locks and BroadcastChannel support.',
    );
    this.name = 'BrowserSessionLockUnavailableError';
  }
}

/** Serialize cookie mutations across every tab sharing this browser origin. */
export const withBrowserSessionLock = async <T>(operation: () => Promise<T>): Promise<T> => {
  if (
    typeof navigator === 'undefined' ||
    !navigator.locks?.request ||
    typeof BroadcastChannel === 'undefined'
  ) {
    throw new BrowserSessionLockUnavailableError();
  }
  return await navigator.locks.request<Promise<T>>(
    BROWSER_SESSION_LOCK_NAME,
    operation,
  );
};
